export default "__VITE_ASSET__DgaQvG17__"